export default __webpack_public_path__ + "static/media/330_dummy2016-diy01-de.9d78641a.png";